import * as types from '../types/couponTypes';

const initialState = {
  validating: false,
  error: null,
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VALIDATE_COUPON_REQUEST:
      return { ...state, validating: true, error: null };

    case types.VALIDATE_COUPON_SUCCESS:
      return { ...state, validating: false, error: null };

    case types.VALIDATE_COUPON_FAILURE:
      return { ...state, validating: false, error: action.payload };

    case types.CLEAR_COUPON_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default couponReducer;
